/**
 * Set `--app-height` variable to `:root` for use in CSS
 */
const appHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
};

// Add resize listener to change value
window.addEventListener('resize', appHeight);

// Set value once when loaded
appHeight();
